import colors from "vuetify/lib/util/colors";

export default {
  primary: "#8a762c",
  error: "#e0a2a2",
  secondary: colors.grey.lighten5,
  background: "#888888",
  accent: "#b3a677",
  // dark0: "#262b2f",
  // dark1: "#353433",
  // dark2: "#3d3c3a",
  // dark3: "#474643",
  // dark4: "#51504f",
  "grey-light1": "#aaaaaa",
  "grey-light2": "#bbbbbb",
  "grey-light3": "#cccccc",
  "grey-light4": "#dddddd",
  "grey-light5": "#ff0000",
  "yello-light1": "#d4af37",

  dark1: "#262626", //really dark
  dark2: "#4c4c4d",
  dark3: "#585857",
  dark4: "#72726d",

  light1: "#efefee",
  light2: "#eeede7", //a bit green
  light3: "#e2e1d5", // a bit green
  light4: "#eae8e4", // like paper
  light5: "#d5d3cb",
  light6: "#c4c2b6"
};
